const stap3 = {

	init() {

		stap3.betalingstermijnChange();
		stap3.nieuweArbodienstSelected();

		/**
		 * Bind functies aan events dom elementen
		 */
		$('#TERMIJN').change(stap3.betalingstermijnChange);
		$('#nieuweArboSelect').change(stap3.nieuweArbodienstSelected);

	},

	/**
	 * Enable en disable de optie "maatschappij-incasso" ('Nota') wanneer maand, kwartaal of halfjaar wordt gekozen (afhankelijk van company)
	 *
	 * @returns {void}
	 */
	betalingstermijnChange: function() {

		// Verkrijg Company ID
		var c = $('#TERMIJN').data('company-id');

		// Definieer object met niet toegestane waarden per company
		var d = {
			'base': ['maand'],
			'C028': ['maand', 'kwartaal', 'halfjaar'],
			'C030': [],
			'C032': ['maand', 'kwartaal', 'halfjaar'],
		};

		// Kijk of de company id voorkomt in niet array toegestane waarden
		if (!d.hasOwnProperty(c)) {
			c = 'base';
		}

		// Check of er een niet toegestane waarde is
		if ((d[c].indexOf($('#TERMIJN').val()) > -1)) {
			$('#KD_INKASSO').val('Automatische-incasso');
			$('#KD_INKASSO').find('option[value="Maatschappij-incasso"]').attr('disabled', 'true');
		} else {
			$('#KD_INKASSO').find('option[value="Maatschappij-incasso"]').removeAttr('disabled');
		}
		$('#KD_INKASSO').trigger('change');
	},

	/**
	 * Enable en disable de optie "maatschappij-incasso" ('Nota') wanneer maand, kwartaal of halfjaar wordt gekozen (afhankelijk van company)
	 *
	 * @returns {void}
	 */
	nieuweArbodienstSelected: function() {

		if ($('#nieuweArboSelect option[value="' + $('#nieuweArbo').val() + '"]').length == 0) {
			$('#nieuweArboSelect option[value="ONB"]').attr('selected', 'selected').trigger('change.select2');
			$('#nieuweArbo').attr('data-validate', 'required').removeClass('d-none');
		}

		if ($('#nieuweArboSelect').val() !== 'ONB') {
			$('#nieuweArbo').val($('#nieuweArboSelect').val());
		}

		if ($('#nieuweArboSelect').val() == 'ONB') {
			if ($('#nieuweArboSelect option[value="' + $('#nieuweArbo').val() + '"]').length > 0) {
				$('#nieuweArbo').val('');
			}
			$('#nieuweArbo').attr('data-validate', 'required').removeClass('d-none');
		} else if (!$('#nieuweArbo').hasClass('d-none')) {
			$('#nieuweArbo').attr('data-validate', '').addClass('d-none');
		}
	}
};

export default stap3;
